export default __webpack_public_path__ + "static/media/gloryforkorn--og--home.39c50f7b.jpg";